import React from "react";
import {Box, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {baseUrlSelector} from "../../state/config/configSelectors";
import {isTranslated} from "../../utils/i18n";

const AppInfo = ({hub}) => {
  const {t} = useTranslation();

  const baseURL = useSelector(baseUrlSelector);

  return (
    <Box
      sx={{
        width: "480px"
      }}
    >
      {hub.headerLogoURL && (
        <Box
          sx={{
            height: "64px",
            background: theme => theme.palette.primary.main,
            padding: "16px",
            marginBottom: "16px"
          }}
        >
          <Box
            component="img"
            src={baseURL + hub.headerLogoURL}
            alt=""
            sx={{
              height: "32px",
              display: "block",
              margin: "auto"
            }}
          />
        </Box>
      )}
      <Box
        sx={{
          padding: "8px",
          marginBottom: "16px"
        }}
      >
        <Typography variant="h4" color="primary" align="center">
          {hub.name}
        </Typography>
      </Box>
      {isTranslated("components.appInfo.content", t("components.appInfo.content")) ? (
        <Box
          sx={{
            marginBottom: "8px"
          }}
        >
          {t("components.appInfo.content")}
        </Box>
      ) : null}
      <div>
        {t("components.appInfo.poweredBy") + ": "}
        <b>
          DataPortal.AI <i id="dataportalai_version">v1.4</i>
        </b>
      </div>
    </Box>
  );
};

export default AppInfo;
